<template>
  <transition name="VERTICAL" mode="out-in">
    <div v-if="meta.count || isFetching" class="APPOINTMENT-LIST">
      <transition-group
          name="VERTICAL"
          tag="div"
          v-infinite-scroll="{
            offset: 666,
            promise: meta.hasMore && !isFetching && loadMoreAppointments
          }"
          class="APPOINTMENT-LIST-CONTAINER"
          selenium="agenda-container">
        <transition-group
            name="VERTICAL"
            tag="div"
            v-for="(rawAppointments, group, index) in groupedByDateRawAppointments"
            :key="group"
            :selenium="`agenda-date:${index}`"
            class="GROUP">
          <appointment-list-item
              v-for="(appointment, index) in rawAppointments"
              :key="appointment"
              :id="appointment"
              class="LIST-ITEM"
              @onDelete="onDelete"
              :selenium="`agenda-list-item:${index}`"
          />
        </transition-group>
        <template v-if="isFetching">
          <appointment-list-item-placeholder
              v-for="(placeholder, index) in 3"
              :key="`placeholder-${index}`"
              class="LIST-ITEM"
          />
        </template>
      </transition-group>
    </div>
    <appointment-list-placeholder v-else-if="!isUninitialized" />
  </transition>
</template>

<script>
import { subMilliseconds } from 'date-fns';

import appointments from '@/mixins/appointments';

import AppointmentListPlaceholder from './AppointmentListPlaceholder';
import AppointmentListItem from './AppointmentListItem';
import AppointmentListItemPlaceholder from './AppointmentListItemPlaceholder';

export default {
  name: 'appointment-list',
  components: {
    AppointmentListPlaceholder,
    AppointmentListItem,
    AppointmentListItemPlaceholder,
  },
  mixins: [
    appointments,
  ],
  data () {
    return {
      // Used by appointments mixin.
      appointmentsBucketName: 'upcoming',
    };
  },
  computed: {
    isUninitialized () {
      return this.meta.status === this.$options.REQUEST_LIFECYCLE.UNINITIALIZED;
    },
    isFetching () {
      return this.meta.status === this.$options.REQUEST_LIFECYCLE.FETCHING;
    },
  },
  mounted () {
    this.clearAppointments();
    this.loadAppointments();
  },
  methods: {
    async loadAppointments (params) {
      const today = new Date();

      today.setHours(0, 0, 0, 0);

      await this.fetchAppointmentsByDate({
        includeJobs: true,
        bucketName: this.appointmentsBucketName,
        params: {
          after: subMilliseconds(today, 1),
          ...params,
        },
      });
    },
    async loadMoreAppointments () {
      await this.loadAppointments({ from: this.meta.count });
    },
    clearAppointments () {
      this.resetAppointments({ bucketName: this.appointmentsBucketName });
    },
    onDelete (item) {
      this.$emit('onDelete', item);
      this.loadAppointments();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .APPOINTMENT-LIST {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: hidden;

    .VERTICAL-leave-active {
      @include absolute;
    }
  }

  .HEADING {
    @include text-large;
    @include margin(2, 4 0 2);
    font-weight: 700;

    @include tablet {
      @include h5;
    }
  }

  .APPOINTMENT-LIST-CONTAINER {
    @include responsive(border-left, none, 1px solid $color-gray30);
    @include responsive(border-right, none, 1px solid $color-gray30);
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    background-color: white;
    border-top: 1px solid $color-gray30;
    border-bottom: none;
    overflow: auto;
    max-height: 80vh;
  }

  .GROUP {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    transition: all $transition-duration;
  }

  .GROUP-HEADING {
    position: sticky;
    display: flex;
    top: 0;
    align-items: center;
    padding: $unit 2*$unit;
    font-weight: 600;
    background-color: $color-gray20;
    border-bottom: 1px solid $color-gray30;
    transition: all $transition-duration;
  }

  .LIST-ITEM {
    transition: all $transition-duration;
  }
</style>
